import { useState, useMemo } from "react";
import "../../App.css";
import { makeStyles } from "@material-ui/core/styles";
import { width } from "@material-ui/system";
import { useEffect } from "react";
import {
  MuiPickersUtilsProvider,
    KeyboardDateTimePicker,
    KeyboardTimePicker,
    KeyboardDatePicker,
  } from '@material-ui/pickers';
  import Grid from '@material-ui/core/Grid';
  import DateFnsUtils from '@date-io/date-fns';
const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    textAlign: "left",
    backgroundColor: "#3f51b5",
    height: "40px",
    width: "100%"
  },
  content: {
    paddingLeft: theme.spacing.unit * 3
  },
  title: {
    // paddingLeft: theme.spacing.unit*3,
    textAlign: "left",
    color: "#000",
    backgroundColor: "#d9d9d9",
    fontSize: "75%"
  }
}));

const CustomDate = props => {
  const classes = useStyles();
  const {datefrom,dateto} = props
  const [curdatefrom, SetCurdatefrom] = useState(datefrom)
  const [curdateto, SetCurdateto] = useState(dateto)
  useEffect(() => {
    SetCurdatefrom(datefrom);
  }, [datefrom])
  useEffect(() => {
    SetCurdateto(dateto);
  }, [dateto])
  
    const handleDateFromChange = (date) => {
       // SetCurdatefrom(date);
       props.onDateFromChange(date)
    };
    const handleDateToChange = (date) => {
        //SetCurdateto(date);
        props.onDateToChange(date)
      };
    //let dateValue = moment(null)
    //let options = {year: 'numeric', month: 'numeric', day: 'numeric' };

     // <DatePicker selected={dateValue}
     return (
     <div className = {'row data-time-pick'} key={props.col.key} style={{display: 'flex', marginBottom: '10px', alignItems: 'center'}}>
        <label className = {'col-lg-2 component_label'}>
          {props.col.name} 
        </label>
        <div className = {'col-lg-9'} style={{ alignItems: 'right' }}>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <Grid container justifyContent="space-around">
        <KeyboardDateTimePicker
          disableToolbar
          variant="inline"
          autoOk={true}
          format="dd/MM/yyyy hh:mm"
          margin="normal"
          id="date-picker-inline"
          value={curdatefrom}
          onChange={handleDateFromChange}
          KeyboardButtonProps={{
            'aria-label': 'change date',
          }}
          />
          <label >
          по 
        </label>
        <KeyboardDateTimePicker
          disableToolbar
          autoOk={true}
          variant="inline"
          format="dd/MM/yyyy hh:mm"
          margin="normal"
          id="date-picker-inline"
          value={curdateto}
          onChange={handleDateToChange}
          KeyboardButtonProps={{
            'aria-label': 'change date',
          }}
        />
        
      </Grid>
    </MuiPickersUtilsProvider>
        </div>
      </div>
   );
};
export default CustomDate;